import React from 'react';

import colors from '../sl-colors';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const UserAdd = ({ color = colors.gray['600'], width = 24, height = 24, ...props }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 3.75C7.70507 3.75 6.25 5.20507 6.25 7C6.25 8.79493 7.70507 10.25 9.5 10.25C11.2949 10.25 12.75 8.79493 12.75 7C12.75 5.20507 11.2949 3.75 9.5 3.75ZM4.75 7C4.75 4.37665 6.87665 2.25 9.5 2.25C12.1234 2.25 14.25 4.37665 14.25 7C14.25 9.62335 12.1234 11.75 9.5 11.75C6.87665 11.75 4.75 9.62335 4.75 7ZM14.8048 3.00935C14.9602 2.6254 15.3975 2.44014 15.7814 2.59556C17.5208 3.29964 18.75 5.00538 18.75 7C18.75 8.99462 17.5208 10.7004 15.7814 11.4044C15.3975 11.5599 14.9602 11.3746 14.8048 10.9907C14.6494 10.6067 14.8346 10.1695 15.2186 10.014C16.411 9.53135 17.25 8.36275 17.25 7C17.25 5.63725 16.411 4.46865 15.2186 3.98596C14.8346 3.83054 14.6494 3.3933 14.8048 3.00935ZM7.97262 14.25H8H12C12.4142 14.25 12.75 14.5858 12.75 15C12.75 15.4142 12.4142 15.75 12 15.75H8C7.05786 15.75 6.38881 15.7504 5.86243 15.7863C5.34279 15.8218 5.0172 15.8893 4.75628 15.9974C3.95994 16.3272 3.32725 16.9599 2.99739 17.7563C2.88931 18.0172 2.82178 18.3428 2.78632 18.8624C2.75041 19.3888 2.75 20.0579 2.75 21C2.75 21.4142 2.41421 21.75 2 21.75C1.58579 21.75 1.25 21.4142 1.25 21V20.9726C1.25 20.0639 1.24999 19.3438 1.2898 18.7603C1.33047 18.1643 1.41517 17.6564 1.61157 17.1823C2.09367 16.0184 3.01837 15.0937 4.18225 14.6116C4.65641 14.4152 5.16431 14.3305 5.76032 14.2898C6.34374 14.25 7.0639 14.25 7.97256 14.25H7.97262ZM19.75 15C19.75 14.5858 19.4142 14.25 19 14.25C18.5858 14.25 18.25 14.5858 18.25 15V17.25H16C15.5858 17.25 15.25 17.5858 15.25 18C15.25 18.4142 15.5858 18.75 16 18.75H18.25V21C18.25 21.4142 18.5858 21.75 19 21.75C19.4142 21.75 19.75 21.4142 19.75 21V18.75H22C22.4142 18.75 22.75 18.4142 22.75 18C22.75 17.5858 22.4142 17.25 22 17.25H19.75V15Z"
      fill={color}
    />
  </svg>
);

export default UserAdd;
